import { Button, Container, Grid, Icon, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { CourseDto, CourseService } from "../../../api/psc";
import {
    EmptyListMessage,
    HelpIconButton,
    PageHeader,
    Spinner,
} from "../../../components/exports";
import useDynamicList from "../../../hooks/UseDynamicList";
import CourseItem from "../components/CourseItem";

export default function ListCourses() {
    const manager = useDynamicList<CourseDto>(async (offset) => {
        return CourseService.getCourses("1");
    });

    if (manager.requestInProgress) {
        return <Spinner />;
    }

    return (
        <Container maxWidth="md">
            <PageHeader
                title="لیست دوره های آموزشی"
                action={
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Link to="/course/history">
                            <Button
                                variant="contained"
                                startIcon={<Icon>history</Icon>}
                            >
                                تاریخچه دوره ها
                            </Button>
                        </Link>
                        <HelpIconButton tag="courses" />
                    </Stack>
                }
            />

            {manager.empty && (
                <EmptyListMessage message="دوره آموزشی یافت نشد" />
            )}

            <Grid container spacing={1.5}>
                {manager.results.map((c) => {
                    return (
                        <Grid item xs={12} sm={12} md={6} key={c.id}>
                            <CourseItem course={c} />
                        </Grid>
                    );
                })}
            </Grid>
        </Container>
    );
}
